import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    openId: null,
    code: null
  },
  getters: {
    getOpenId: state => state.openId,
    getCode: state => state.code
  },
  mutations: {
    setOpenId (state, openId) {
      state.openId = openId
    },
    setCode (state, code) {
      state.code = code
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store.js